// this file is needed to be able to mock NODE_ENV in JEST tests
export const ENVIRONMENT = process.env.NODE_ENV;